import React from "react";
import { Flex, Box, Image, Button, Link } from "@chakra-ui/react";

const Section6 = () => {
  return (
    <div>
      <Flex
        mt={{ base: "100px", md: "150px" }}
        w="100%"
        alignItems="center"
        justifyContent="center"
        display={{ base: "none", md: "flex" }}
      >
        <Box
          w={{ base: "80%", md: "80%" }}
          backgroundImage="linear-gradient(127deg, #7272fb 0, #b8e1ff 99%);"
          borderRadius="20px"
          h="700px"
          p="40px"
          overflow="hidden"
        >
          <Flex
            w="100%"
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            <Box fontWeight="600" fontSize={{ base: "30px", md: "50px" }}>
              Start reading your portfolio's pulse
            </Box>

            <Link href="/start" _hover={{ textDecoration: "none" }}>
              {" "}
              <Button
                _hover={{ bg: "black", color: "white" }}
                mt="10px"
                bg="black"
                color="white"
                borderRadius="10px"
              >
                Get started
              </Button>
            </Link>

            <Box>
              <Image mt="10px" src="https://i.imgur.com/bb04PED.png" />
            </Box>
          </Flex>
        </Box>
      </Flex>
    </div>
  );
};

export default Section6;
